export const APA_RELATED_TRANING_REQUEST = 'APA_RELATED_TRANING_REQUEST';
export const APA_RELATED_TRANING_SUCCESS = 'APA_RELATED_TRANING_SUCCESS';
export const APA_RELATED_TRANING_FAIL    = 'APA_RELATED_TRANING_FAIL';

